import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";
export type AlertType = "error" | "info" | "success" | "warn";
export interface AlertData {
    message: string;
    type: AlertType;
    index?: number;
    time?: number;
}
interface InitialState {
    data: AlertData | null;
}
const initialState: InitialState = {
    data: null,
};
const slice = createSlice({
    name: "alert",
    initialState,
    reducers: {
        setAlert: (state, action: PayloadAction<AlertData | null>) => {
            if (!action.payload) {
                state.data = null;
                return;
            }
            if (!action.payload.time) {
                action.payload.time = 3000;
            }
            action.payload.index = state.data ? state.data.index! + 1 : 0;

            state.data = action.payload;
        },
    },
});

export default slice.reducer;
export const { setAlert } = slice.actions;
export const selectAlertData = (state: RootState) => state.alert.data;
